import { render, staticRenderFns } from "./ChatBlockAddUpdate.vue?vue&type=template&id=50d72e54&"
import script from "./ChatBlockAddUpdate.vue?vue&type=script&lang=js&"
export * from "./ChatBlockAddUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports